import React, { useEffect, useRef, useState } from 'react';
import * as S from './styles';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import NewUserModal from '../NewUserModal';
import UserItem from '../UserItem';
import SearchIcon from '@mui/icons-material/Search';
import { useMessage } from 'newComponents/ChatWhatsapp/context/MessageContext';
import DialogComponent from 'newComponents/DialogComponent';
import { FormControlLabel } from '@material-ui/core';

const WhasappUsers = () => {
	const { allUsers, users, isUsersLoading, addUser, setUsers, handleDeactivateUser } = useMessage();
	const [ searchQuery, setSearchQuery ] = useState( '' );
	const [ userToEdit, setUserToEdit ] = useState( null );
	const [ userToRemove, setUserToRemove ] = useState( null );
	const [ isNewUserModalOpen, setIsNewUserModalOpen ] = useState( false );
	const [ isMenuOpen, setIsMenuOpen ] = useState( false );
	const [ newUserModalPosition, setNewUserModalPosition ] = useState( { top: 0, left: 0 } );
	const anchorRef = useRef( null );

	const removeUser = async ( ) => {
		if ( userToRemove ) {
			handleDeactivateUser( userToRemove );
			setUserToRemove( null );
			setIsMenuOpen( false );
		}
	};

	const handleOpenNewUserModal = () => {
		if ( anchorRef.current ) {
			const rect = anchorRef.current.getBoundingClientRect();
			setNewUserModalPosition( {
				top  : rect.bottom + window.scrollY,
				left : rect.left + window.scrollX
			} );
		}
		setIsNewUserModalOpen( ( prev ) => !prev );
	};

	const handleCloseNewUserModal = () => {
		setIsNewUserModalOpen( false );
	};

	const handleEditUserButton = ( user ) => {
		setUserToEdit( user );
		setIsNewUserModalOpen( true );
		setNewUserModalPosition( {
			top  : user.top + window.scrollY,
			left : user.left + window.scrollX
		} );
	};

	const handleRemoveUser = ( id ) => {
		setUserToRemove( id );
		setIsMenuOpen( true );
	};

	useEffect( () => {
		const filteredUsers = allUsers.filter( user => user.name.toLowerCase().includes( searchQuery.toLowerCase() ) );
		setUsers( filteredUsers );
	}, [ searchQuery, allUsers, setUsers ] );

	return (
		<>
			<S.Container>
				{isNewUserModalOpen && <NewUserModal
					onClose={handleCloseNewUserModal}
					position={newUserModalPosition}
					modalRef={anchorRef}
					addUser={addUser}
					userToEdit={userToEdit}
					handleSetUserToEdit={setUserToEdit}
				/>}
				<S.TitleContainer>
					<S.Title>Todos os usuários</S.Title>
					<S.ButtonAddUser onClick={handleOpenNewUserModal}>
						<AddCircleOutlineIcon />
					</S.ButtonAddUser>
				</S.TitleContainer>
				<S.SearchContainer>
					<SearchIcon style={{
						position  : 'absolute',
						left      : '12px',
						top       : '50%',
						transform : 'translateY(-50%)',
						color     : '#aebac1'
					}} />
					<S.SearchInput
						type="text"
						placeholder="Pesquisar usuário"
						value={searchQuery}
						onChange={( e ) => setSearchQuery( e.target.value )}
					/>
				</S.SearchContainer>
				{isUsersLoading ? ( <S.LoadingMessageContainer>
					<S.LoadingMessage>Carregando usuários...</S.LoadingMessage>
				</S.LoadingMessageContainer> ) : (
					<S.UserList>
						{users.map( ( user ) => (
							<>
								<S.UserItemContainer key={user.id} >
									<UserItem name={user.name} profileType={user.profileTypeName} />
									<FormControlLabel
										control={
											<S.GreenSwitch
												checked={true}
												onChange={() => handleRemoveUser( user.acordoFechadoId )}
												value={true}
											/>
										}/>
									<S.UserItemButton onClick={() => handleEditUserButton( user )}>Editar</S.UserItemButton>
								</S.UserItemContainer>
							</>
						) )}
					</S.UserList> )}
				<DialogComponent
					confirmation={isMenuOpen}
					closeFunction={() => setIsMenuOpen( false )}
					callback={removeUser}
					title={'Atenção!'}
					subText={'Desativar o usuário irá remover-lo dos chats que está vinculado. Deseja prosseguir?'}
				/>
			</S.Container>
		</>
	);
};

export { WhasappUsers };
